<script>
import store from '@/store';
import PopupChangePassStore from '@/views/popupSearch/popup_change_pass/store';
import template from './template.html';
import './style.scss';
import { mapActions, mapMutations, mapState } from 'vuex';
import AnsCheckbox from '@/components/ansCheckbox/index.vue';
import { password_input_rule } from '@/utils/constants';
import messages, { MSG_TITLE, MSG_TYPE, MSG_BUTTON } from '@/utils/messages';
import helpers from '@/utils/helpers';
import { regexpValidateEmail } from '@/utils/constants';

var PopupInvite = {
    template: template,
    components: { AnsCheckbox },
    beforeCreate() {
        if (!store.hasModule('PopupChangePassStore')) {
            store.registerModule('PopupChangePassStore', PopupChangePassStore);
        }
    },
    data() {
        return {
            errors: [],
            isPopupPassword: false,
            password_input_rule: password_input_rule,
            havePass: false
        };
    },
    emits: ['close', 'reload'],
    props: {
        isPassword: {
            type: [String, Number],
            default: ''
        },
        isFillPass: {
            type: Boolean,
            default: false
        },
        loginid: String
    },
    mounted() {
        window.addEventListener('keydown', this.handleKeydown);
        this.havePass = this.isPassword ? true : false;
        this.data.oldPassword = this.isFillPass ? this.isPassword : '';
    },
    beforeDestroy() {
        window.removeEventListener('keydown', this.handleKeydown);
    },
    computed: {
        ...mapState('PopupChangePassStore', ['authorityOptions', 'data']),
        disableButton() {
            let disable = false;
            if (this.data.oldPassword == '' || this.data.newPassword == '' || this.data.newPasswordConfirm == '') {
                disable = true;
            }
            return disable;
        },
        isMobile() {
            return helpers.checkIfMobile();
        }
    },
    methods: {
        ...mapMutations('app', ['showHeaderError', 'setScreenId', 'setHeader', 'showModalMessage', 'hideModalMessage', 'hideHeaderError']),
        ...mapMutations('PopupChangePassStore', ['resetData']),
        ...mapActions('PopupChangePassStore', ['changePassWord']),
        validateEmail(event) {
            const id = event.target.id;
            const string = event.target.value;
            const regexp = regexpValidateEmail;
            if (regexp.test(string) || string.trim() == '') {
                this.errors = this.errors.filter((error) => error.name !== id);
            } else {
                const existingErrorIndex = this.errors.findIndex((error) => error.name === id);
                let error = {
                    name: id,
                    message: 'メールアドレスのフォーマットが正しくありません。'
                };
                if (existingErrorIndex !== -1) {
                    this.errors.splice(existingErrorIndex, 1, error);
                } else {
                    this.errors.push(error);
                }
            }
        },
        closePopupChangePassword() {
            this.$emit('close', '');
            this.resetData();
            this.removeError('oldPassword');
            this.removeError('newPassword');
            this.removeError('newPasswordConfirm');
        },
        // checkOldPass() {
        //     this.data.oldPassword = this.data.oldPassword.trim();
        //     if (
        //         this.isPassword != this.data.oldPassword &&
        //         this.data.oldPassword
        //     ) {
        //         this.addError({
        //             name: 'oldPassword',
        //             message: '旧パスワードが違います。'
        //         });
        //     } else {
        //         this.removeError('oldPassword');
        //     }
        //     if (this.data.newPassword == this.data.oldPassword) {
        //         this.addError({
        //             name: 'newPassword1',
        //             message:
        //                 '新パスワードが、旧パスワードと同じです。変更して下さい。'
        //         });
        //     } else {
        //         this.removeError('newPassword1');
        //     }
        // },
        // checkPassword() {
        //     this.data.newPassword = this.data.newPassword.trim();
        //     this.data.newPasswordConfirm = this.data.newPasswordConfirm.trim();
        //     this.isValidPassword = true;
        //     const regex =
        //         /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$#])[A-Za-z\d@$#]{10,}$/;
        //     this.isValidPassword = regex.test(this.data.newPassword);
        //     if (this.data.newPassword) {
        //         if (!this.isValidPassword) {
        //             this.addError({
        //                 name: 'newPassword',
        //                 message: 'パスワードの形式が正しくありません。'
        //             });
        //         } else {
        //             this.removeError('newPassword');
        //         }
        //     } else {
        //         this.removeError('newPassword');
        //     }
        //     if (this.data.newPasswordConfirm && this.data.newPassword) {
        //         if (this.data.newPassword !== this.data.newPasswordConfirm) {
        //             this.addError({
        //                 name: 'newPasswordConfirm',
        //                 message:
        //                     'パスワードとパスワード(確認用)が一致しません。'
        //             });
        //         } else {
        //             this.removeError('newPasswordConfirm');
        //         }
        //     } else {
        //         this.removeError('newPasswordConfirm');
        //     }
        //     if (this.data.newPassword == this.data.oldPassword) {
        //         this.addError({
        //             name: 'newPassword1',
        //             message:
        //                 '新パスワードが、旧パスワードと同じです。変更して下さい。'
        //         });
        //     } else {
        //         this.removeError('newPassword1');
        //     }
        // },
        removeError(fieldName) {
            this.errors = this.errors.filter((e) => e.name !== fieldName);
        },
        addError(message) {
            this.errors.push(message);
        },
        validatePassword() {
            const oldPassword = this.data.oldPassword.trim();
            const newPassword = this.data.newPassword.trim();
            const newPasswordConfirm = this.data.newPasswordConfirm.trim();
            // check old_password is not correct
            if (this.isPassword != oldPassword) {
                this.addError({
                    name: 'oldPassword',
                    message: '旧パスワードが違います。'
                });
            } else {
                this.removeError('oldPassword');
            }
            // check old_password matches new_password
            if (oldPassword == newPassword) {
                this.addError({
                    name: 'newPassword1',
                    message: '新パスワードが、旧パスワードと同じです。変更して下さい。'
                });
            } else {
                this.removeError('newPassword1');
            }
            // check format new_password
            const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$#])[A-Za-z\d@$#]{10,}$/;
            if (!regex.test(newPassword)) {
                this.addError({
                    name: 'newPassword',
                    message: 'パスワードの形式が正しくありません。'
                });
            } else {
                this.removeError('newPassword');
            }
            // check new_password doesnt match new_password_confirm
            if (newPassword != newPasswordConfirm) {
                this.addError({
                    name: 'newPasswordConfirm',
                    message: 'パスワードとパスワード(確認用)が一致しません。'
                });
            } else {
                this.removeError('newPasswordConfirm');
            }
        },
        changePass() {
            this.validatePassword();
            let errorMsg = helpers.renderMsgErr(this.errors);
            if (errorMsg != '') {
                this.showModalMessage({
                    type: MSG_TYPE.ERROR,
                    title: MSG_TITLE.E001,
                    content: errorMsg,
                    okText: MSG_BUTTON.okText
                });
            } else {
                this.showModalMessage({
                    type: MSG_TYPE.CONFIRM,
                    title: MSG_TITLE.C001,
                    content: messages.C002,
                    cancelText: 'いいえ',
                    okText: 'はい',
                    callback: (ok) => {
                        if (ok) {
                            this.changePassWord({
                                body: {
                                    loginid: this.loginid ?? '',
                                    oldPassword: this.data.oldPassword,
                                    newPassword: this.data.newPassword,
                                    newPasswordConfirm: this.data.newPasswordConfirm
                                },
                                callback: (response) => {
                                    console.log(response);
                                    this.showModalMessage({
                                        type: MSG_TYPE.SUCCESS,
                                        title: MSG_TITLE.S002,
                                        content: messages.S002,
                                        okText: 'OK',
                                        callback: (ok) => {
                                            if (ok) {
                                                this.closePopupChangePassword();
                                                this.$emit('reload');
                                            }
                                        }
                                    });
                                }
                            });
                        }
                    }
                });
            }
        },
        handleKeydown(event) {
            if (event.key === 'Escape') {
                this.closePopupChangePassword();
            }
            document.getElementById('button-mail').blur();
        }
    }
};
export default PopupInvite;
</script>
